import type { APITriplet, ModelTriplet } from '$lib/resource-type';

import { isBuiltinAPI } from './api-types';
import { isBuiltinModel } from './models';
import { ServiceSubtypes } from './services';

export const isBuiltinVisionColorDetectorService = (
  api: APITriplet,
  model: ModelTriplet
) =>
  isBuiltinAPI(api, ServiceSubtypes.VISION) &&
  isBuiltinModel(model, 'color_detector');

export const isBuiltinVisionMlModelService = (
  api: APITriplet,
  model: ModelTriplet
) =>
  isBuiltinAPI(api, ServiceSubtypes.VISION) && isBuiltinModel(model, 'mlmodel');
